import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";

@Injectable()
export class BaseService {
  private headers: HttpHeaders;

  constructor() {
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
  }

  getHeaders(): HttpHeaders {
    return this.headers;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api-base.service.ts